<template>
  <v-row class="px-0">
    <v-col class="py-0">
      <div class="body-2">{{ $t('LoggedArea.Settings.Specialty.subtitle') }}</div>
      <v-sheet>
        <v-chip-group column active-class="purple darken-4 white--text">
          <v-chip
            v-for="specialty in specialties"
            :key="specialty"
            @click="$emit('changespecialty', specialty)"
            :style="specialty == user.specialty ? `color:${colorSpecialty}` : 'color:#000'"
          >{{ specialty }}</v-chip>
        </v-chip-group>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ["specialties"],
  data() {
    return {
      colorSpecialty: "#4A148C",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style>
</style>